import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class RegistrationReportService {

  constructor(private backendService:BackendService) { }
  
  private path = '/reports';

  
  

  savePersonalDetails(currentDetail, tabid: any){
  
    return this.backendService.post (this.path, {data: currentDetail, tabid: tabid});
  }


  getPersonalDetails(){
    
    return this.backendService.get (this.path);
  }
  
  getUserDetails(){
    
    return this.backendService.get (this.path + "/userdetails");

  }

  getCategory(){
    return this.backendService.get(this.path + '/category');
  }
  getRegistrationReport(){
  
          return this.backendService.get(this.path + '/report');
  }

}